/** 角色换装配置 — 与后端 /api/outfit 及地图 MAP_STATE 同步 */

export const HAT_OPTIONS = [
  { id: 'none', label: '无' },
  { id: 'cap', label: '鸭舌帽' },
  { id: 'bow', label: '蝴蝶结' },
  { id: 'crown', label: '小皇冠' },
  { id: 'beanie', label: '毛线帽' }
]

export const TOP_OPTIONS = [
  { id: 'tee', label: 'T 恤' },
  { id: 'hoodie', label: '卫衣' },
  { id: 'vest', label: '马甲' }
]

export const COLOR_PRESETS = [
  { id: 'ocean', label: '海洋', hair: '#5b8fd4', hairLight: '#8eb8f0', shirt: '#4ecdc4', shirtDark: '#2a9d8f', pants: '#2d4059', pantsDark: '#1a2634', accent: '#7ee8fa' },
  { id: 'sunset', label: '晚霞', hair: '#c17f59', hairLight: '#e8a87c', shirt: '#ff9f43', shirtDark: '#d97828', pants: '#6b4c35', pantsDark: '#4a3424', accent: '#ffd166' },
  { id: 'forest', label: '森林', hair: '#3d6b4f', hairLight: '#6b9e7a', shirt: '#52b788', shirtDark: '#2d6a4f', pants: '#1b4332', pantsDark: '#081c15', accent: '#95d5b2' },
  { id: 'grape', label: '葡萄', hair: '#6c3483', hairLight: '#9b59b6', shirt: '#9b59b6', shirtDark: '#6c3483', pants: '#2c1654', pantsDark: '#1a0f2e', accent: '#d7bde2' },
  { id: 'candy', label: '糖果', hair: '#e84393', hairLight: '#fd79a8', shirt: '#fd79a8', shirtDark: '#e84393', pants: '#6c5ce7', pantsDark: '#4834d4', accent: '#ffeaa7' },
  { id: 'midnight', label: '午夜', hair: '#2c3e50', hairLight: '#566573', shirt: '#5d6d7e', shirtDark: '#34495e', pants: '#1c2833', pantsDark: '#0b1014', accent: '#85c1e9' }
]

export const DEFAULT_OUTFIT = {
  hat: 'none',
  top: 'tee',
  hair: '#5b8fd4',
  hairLight: '#8eb8f0',
  skin: '#ffcc99',
  skinShade: '#e8a86a',
  shirt: '#4ecdc4',
  shirtDark: '#2a9d8f',
  pants: '#2d4059',
  pantsDark: '#1a2634',
  shoe: '#1e1e1e',
  accent: '#7ee8fa'
}

const VALID_HATS = new Set(HAT_OPTIONS.map(o => o.id))
const VALID_TOPS = new Set(TOP_OPTIONS.map(o => o.id))
const HEX_RE = /^#[0-9a-fA-F]{6}$/

function normColor (v, fallback) {
  if (typeof v === 'string' && HEX_RE.test(v)) return v
  return fallback
}

/** 合并并校验换装数据 */
export function normalizeOutfit (raw) {
  const base = { ...DEFAULT_OUTFIT }
  if (!raw || typeof raw !== 'object') return base
  const hat = typeof raw.hat === 'string' && VALID_HATS.has(raw.hat) ? raw.hat : base.hat
  const top = typeof raw.top === 'string' && VALID_TOPS.has(raw.top) ? raw.top : base.top
  return {
    hat,
    top,
    hair: normColor(raw.hair, base.hair),
    hairLight: normColor(raw.hairLight, base.hairLight),
    skin: normColor(raw.skin, base.skin),
    skinShade: normColor(raw.skinShade, base.skinShade),
    shirt: normColor(raw.shirt, base.shirt),
    shirtDark: normColor(raw.shirtDark, base.shirtDark),
    pants: normColor(raw.pants, base.pants),
    pantsDark: normColor(raw.pantsDark, base.pantsDark),
    shoe: normColor(raw.shoe, base.shoe),
    accent: normColor(raw.accent, base.accent)
  }
}

export function outfitToPalette (outfit) {
  const o = normalizeOutfit(outfit)
  return {
    hair: o.hair,
    hairLight: o.hairLight,
    skin: o.skin,
    skinShade: o.skinShade,
    shirt: o.shirt,
    shirtDark: o.shirtDark,
    pants: o.pants,
    pantsDark: o.pantsDark,
    shoe: o.shoe,
    accent: o.accent
  }
}

export function applyColorPreset (outfit, presetId) {
  const preset = COLOR_PRESETS.find(p => p.id === presetId)
  if (!preset) return { ...outfit }
  return normalizeOutfit({
    ...outfit,
    hair: preset.hair,
    hairLight: preset.hairLight,
    shirt: preset.shirt,
    shirtDark: preset.shirtDark,
    pants: preset.pants,
    pantsDark: preset.pantsDark,
    accent: preset.accent
  })
}

export function cloneOutfit (outfit) {
  return normalizeOutfit(outfit)
}
